import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleSize", "titleProps", "description", "layout", "alignment"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { ALIGNMENT } from "../../constants/alignment";
import React from 'react';
import PropTypes from 'prop-types';
import GridContainer from "../grid-container";
import { HEADLINE_DEFAULT_SIZE, HEADLINE_SIZES } from "../typography";
import { StyledHeadlineAndText } from "./headline-module.styles";
import { jsx as _jsx } from "react/jsx-runtime";
export var LAYOUT = {
  DEFAULT: 'default',
  COMPACT: 'compact'
};
var HeadlineModule = function HeadlineModule(props) {
  var _rest$style;
  var title = props.title,
    titleSize = props.titleSize,
    titleProps = props.titleProps,
    description = props.description,
    layout = props.layout,
    alignment = props.alignment,
    rest = _objectWithoutProperties(props, _excluded);
  var textColor = rest === null || rest === void 0 ? void 0 : (_rest$style = rest.style) === null || _rest$style === void 0 ? void 0 : _rest$style.color;
  var headlineStyle = {};
  if (textColor) {
    headlineStyle.color = textColor;
  }
  return /*#__PURE__*/_jsx(GridContainer, _objectSpread(_objectSpread({}, rest), {}, {
    children: /*#__PURE__*/_jsx(StyledHeadlineAndText, {
      title: title,
      titleSize: titleSize,
      description: description,
      layout: layout,
      alignment: alignment,
      descriptionProps: {
        'data-qa': 'headline-description',
        'data-testid': 'headline-module-description'
      },
      titleProps: titleProps,
      style: headlineStyle
    })
  }));
};
HeadlineModule.displayName = 'HeadlineModule';
HeadlineModule.propTypes = {
  description: PropTypes.string,
  layout: PropTypes.oneOf(Object.values(LAYOUT)).isRequired,
  title: PropTypes.string.isRequired,
  titleSize: PropTypes.oneOf(Object.values(HEADLINE_SIZES)),
  alignment: PropTypes.oneOf(Object.values(ALIGNMENT)),
  titleProps: PropTypes.object
};
HeadlineModule.defaultProps = {
  description: null,
  titleSize: HEADLINE_DEFAULT_SIZE,
  alignment: ALIGNMENT.DEFAULT,
  titleProps: null
};
export default HeadlineModule;